// src/components/Fuß/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-links">
        <Link to="/impressum">Impressum</Link>
        <span>|</span>
        <Link to="/agb">AGB</Link>
        <span>|</span>
        <Link to="/datenschutz">Datenschutz</Link>
      </div>
      <p className="footer-copy">© {new Date().getFullYear()} prosperly GmbH</p>
    </footer>
  );
}

export default Footer;
